var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { addVolunteersFunctionDef } from '../../../../backend/features/shift/shared';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { showWizardDialog } from '@juvare/common-form-ui/showWizardDialog';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
export const useAddShiftForVolunteer = ({ participantId, participantFullName, steps, onAfterSubmit }) => {
    const { t } = useMissionsTranslation();
    const addVolunteersPlatformFn = useTypedPlatformFunction(addVolunteersFunctionDef);
    const handleSubmit = (_a) => __awaiter(void 0, [_a], void 0, function* ({ shift, position }) {
        try {
            yield addVolunteersPlatformFn({
                volunteers: [{ accountId: participantId, positionId: position.id }],
                shiftId: shift.id,
            });
            showAlertSnackbar({
                message: t('shiftVolunteerManagementWizard.snackbars.shiftAdded'),
                autoHideDuration: 2000,
                type: 'success',
            });
            onAfterSubmit();
        }
        catch (error) {
            handleErrorDialog(error);
        }
    });
    const handleAddShift = () => {
        showWizardDialog({
            maxWidth: 'md',
            onSubmit: handleSubmit,
            submitButtonLabel: t('shiftVolunteerManagementWizard.addShiftSubmitButton'),
            title: t('shiftVolunteerManagementWizard.addShiftDialogTitle', { participantFullName }),
            steps,
            data: {},
        });
    };
    return { handleAddShift };
};
